const basico6 = {
    titulo: `JavaScript: estructuras condicionales anidadas`,
    problemas: [
        {
            codigo: 1,
            descripcion: `Estamos en presencia de una estructura condicional anidada cuando por la rama del verdadero o el falso de una estructura condicional hay otra estructura condicional.
La sintaxis básica de una estructura condicional anidada puede ser:
<pre>
if (condición1) {
    // código a ejecutar si la condición1 es verdadera
} else {
    if (condición2) {
        // código a ejecutar si la condición2 es verdadera
    } else {
        // código a ejecutar si la condición2 es falsa
    }
}
</pre>
Problema: Confeccionar un programa que a partir de tres notas de un alumno almacenadas en variables, calcule el promedio e imprima alguno de estos mensajes:
<pre>
Si el promedio es >=7 mostrar "Promocionado".
Si el promedio es >=4 y <7 mostrar "Regular".
Si el promedio es <4 mostrar "Reprobado".
</pre>
`,
            programa: `let nota1 = 8
let nota2 = 10
let nota3 = 9
let prom = (nota1 + nota2 + nota3) / 3
if (prom >= 7) {
  console.log("Promocionado")
} else {
  if (prom >= 4) {
    console.log("Regular")
  } else {
    console.log("Reprobado")
  }
}`,
            solucion: "'Promocionado'",
        }, {
            codigo: 2,
            descripcion: `Se tiene una variable entera cargada por asignación, mostrar si es positivo, negativo o nulo (es decir cero)`,
            programa: `let num = -30
if (num === 0) {
  console.log("Nulo")
} else {
  if (num > 0) {
    console.log("Positivo")
  } else {
    console.log("Negativo")
  }
}`,
            solucion: "'Negativo'",
        }, {
            codigo: 3,
            descripcion: `Se cargan por asignación tres variables numéricas. Mostrar por la consola el mayor de ellos.`,
            programa: `let num1 = 7
let num2 = 20
let num3 = 5
if (num1 > num3) {
  if (num1 > num3) {
    console.log(num1)
  } else {
    console.log(num3)
  }
} else {
  if (num2 > num3) {
    console.log(num2)
  } else {
    console.log(num3)
  }
}`,
            solucion: "20",
        }, {
            codigo: 4,
            descripcion: `Se carga por asignación un número entero positivo de hasta tres cifras, se debe mostrar un mensaje indicando si tiene 1, 2, o 3 cifras. Mostrar un mensaje de 'error' si el número de cifras es mayor a 3 o si tiene un valor negativo.`,
            programa: `let num = 777
if (num < 0) {
  console.log("Error")
} else {
  if (num < 10) {
    console.log("tiene 1 digito")
  } else {
    if (num < 100) {
      console.log("tiene 2 digitos")
    } else {
      if (num < 1000) {
        console.log("tiene 3 digitos")
      } else {
        console.log("Error")
      }
    }
  }
}`,
            solucion: "'tiene 3 digitos'",
        }, {
            codigo: 5,
            descripcion: `Un postulante a un empleo, realiza un test de capacitación y se obtiene la siguiente información: 
Cantidad total de preguntas que se le realizaron y la cantidad de preguntas que contestó correctamente.
Se pide confeccionar un programa que informe el nivel del mismo según el porcentaje de respuestas correctas que ha obtenido, y sabiendo que:
<pre>        
Nivel máximo:       Porcentaje>=90%.
Nivel medio:        Porcentaje>=75% y <90%.
Nivel regular:	    Porcentaje>=50% y <75%.
Fuera de nivel:	    Porcentaje<50%.
</pre>`,
            programa: `let totalPreguntas = 10
let totalCorrectas = 8
let porcentaje = totalCorrectas * 100 / totalPreguntas
if (porcentaje >= 90) {
  console.log("Nivel máximo")
} else {
  if (porcentaje >= 75) {
    console.log("Nivel medio")
  } else {
    if (porcentaje >= 50) {
      console.log("Nivel regular")
    } else {
      console.log("Fuera de nivel")
    }
  }
}`,
            solucion: "'Nivel medio'",
        }, {
            codigo: 6,
            descripcion: `Se tiene almacenado en una variable alguna de las siguientes palabras claves de JavaScript: "let", "if", "else" u otro texto. Mostrar un mensaje que se trata de una palabra clave de JavaScript, o en su defecto indicar que no es una palabra clave si tiene un string diferente.`,
            programa: `let palabra = "private"
if (palabra === "let") {
  console.log("Es una palabra clave")
} else {
  if (palabra === "if") {
    console.log("Es una palabra clave")
  } else {
    if (palabra === "else") {
      console.log("Es una palabra clave")
    } else {
      console.log("No es una palabra clave")
    }
  }
}`,
            solucion: "'No es una palabra clave'",
        }, {
            codigo: 7,
            descripcion: `Almacenar por asignación la altura de una persona en cm. Mostrar alguno de los siguientes mensajes dependiendo de la altura:
<pre>        
"Alta"    si tiene más de 190 cm
"Normal"  si tiene entre 160 cm y menos de 190 cm
"Baja"    si tiene menos de 160 cm.
</pre>`, programa: `let altura = 180
if (altura > 190) {
  console.log("Alta")
} else {
  if (altura >= 160) {
    console.log("Normal")
  } else {
    console.log("Baja")
  }
}`,
            solucion: "'Normal'",
        }
    ]
}

export default basico6;